export default "__VITE_ASSET__wee4ijHI__"